import { can } from '@pl/domain';
import { NavLink, Outlet } from 'react-router';
import { useMe, useOrg } from '../../lib/queries';
import { Icon, type IconName } from '../../ui/Icon';
import s from './SettingsLayout.module.css';

/** The sub-nav, in the mockup's order. An entry with `later` has no page yet and is not a link. */
const ITEMS: { label: string; icon: IconName; to?: string; later?: string }[] = [
  { label: 'Company', icon: 'home', later: 'Later' },
  { label: 'Sites', icon: 'site', later: 'Later' },
  { label: 'SKUs', icon: 'stock', to: 'skus' },
  { label: 'Import', icon: 'upload', to: 'import' },
  { label: 'Printing', icon: 'printer', to: 'printing' },
  { label: 'Users', icon: 'users', to: 'users' },
  { label: 'Devices', icon: 'tv', to: 'devices' },
  { label: 'Google Sheets', icon: 'sheet', to: 'sheets' },
  { label: 'WhatsApp', icon: 'chat', to: 'whatsapp' },
];

/** `mockups/office-10-settings-devices.html`: the settings sub-nav beside the page. */
export function SettingsLayout() {
  const me = useMe().data;
  const org = useOrg().data;
  // Test data: for admins, and only while the company is on trial (`liveSince` null, as the API says it).
  const items = me && can(me.role, 'settings') && org?.liveSince === null ? [...ITEMS, { label: 'Test data', icon: 'trash' as const, to: 'test-data' }] : ITEMS;
  return (
    <div className={`settings ${s.slGrid}`}>
      <nav className="subnav" aria-label="Settings">
        <span className="caps">Settings</span>
        {items.map((item) =>
          item.to ? (
            <NavLink key={item.label} to={item.to} className={({ isActive }) => (isActive ? 'on' : undefined)}>
              <Icon name={item.icon} />
              {item.label}
            </NavLink>
          ) : (
            // Not a link and not focusable: there is nothing behind it yet, and a control that goes
            // nowhere reads as broken. The tag says when it arrives.
            <span key={item.label} className={s.slLater}>
              <Icon name={item.icon} />
              <span className={s.slName}>{item.label}</span>
              <small className={s.slTag}>{item.later}</small>
            </span>
          ),
        )}
      </nav>
      <div className={s.slPage}>
        <Outlet />
      </div>
    </div>
  );
}
